import { render, staticRenderFns } from "./MatlabParametersDictionary.vue?vue&type=template&id=48400a1e"
import script from "./MatlabParametersDictionary.vue?vue&type=script&lang=js"
export * from "./MatlabParametersDictionary.vue?vue&type=script&lang=js"
import style0 from "./MatlabParametersDictionary.vue?vue&type=style&index=0&id=48400a1e&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports